import $ from 'jquery';
import widgetFactory from '../../widgetFactory';
import _ from 'lodash';
import AdyenRefusalResponseMapper from '../../../Services/Adyen/AdyenRefusalResponseMapper';
import AdyenRefusalResponseParser from '../../../Services/Adyen/AdyenRefusalResponseParser';
import { CurrentUser } from 'Modules/currentUser';

import { load as lazyScriptLoad } from '../../../Services/lazyScript';

const ZUORA_LIB_URL = 'https://static.zuora.com/Resources/libs/hosted/1.3.0/zuora-min.js';

import premiumShopAbstractForm from './premiumShopAbstractForm';
import { paymentTypes } from './premiumShopAbstractForm';

const widgetName = 'premiumShopFormZuora';
const baseClassname = `js-${widgetName}`;

export const constants = paymentTypes;

let Widget = widgetFactory(widgetName, premiumShopAbstractForm, {
  _create() {
    this._super(baseClassname);
    this.defaultUserFullName = '';
    this._zuoraFormValided = false;
    this._paymentFormSuccessCallback = null;

    this._setDefaultUserFullName();

    this.elements.$paymentMethodIdInput = $('[name*=paymentMethodId]', this.element).first();

    if (_.isEmpty(this.elements.$paymentMethodIdInput)) {
      throw new Error('no paymentMethodId field found');
    }

    this._loadZuoraLib().then(() => {
      this.zuoraLib = window.Z;
      this._onZuoraReady();
    });
  },

  _setDefaultUserFullName() {
    try {
      let currentUser = CurrentUser.get();
      this.defaultUserFullName = currentUser.displayableName;
    } catch (e) {
      /* */
    }
  },

  _attachEvents() {
    $('input', this.elements.$typeSelectContainer).on('change', () =>
      this._updateElementVisibility()
    );

    const onSubmit = (e) => {
      if (this.getPaymentType() === paymentTypes.CREDIT_CARD && this._hasPayment) {
        if (!this._zuoraFormValided) {
          e.preventDefault();
          this.zuoraLib.submit();
        }
      } else if (this.getPaymentType() === paymentTypes.PAYPAL && this._hasPayment) {
        e.preventDefault();

        if (this._paymentFormSuccessCallback) {
          this._paymentFormSuccessCallback();
        }
        this.element.off('submit');
        this.element.submit();
      }

      this.elements.$submitButton.prop('disabled', true);
    };

    this.element.on('submit', onSubmit);
  },

  _onZuoraFormSubmitCallback(response) {
    if (response.success) {
      if (this._paymentFormSuccessCallback) {
        this._paymentFormSuccessCallback();
      }
      this._zuoraFormValided = true;
      this.elements.$paymentMethodIdInput.val(response.refId);

      this.element.off('submit');
      this.element.submit();
    } else {
      this._zuoraFormValided = false;
    }
  },

  _onZuoraFormErrorCallback(key, code, message) {
    const adyenUnknowErrorCode = 'unknown';
    let parsedResponse, responseTranslated;

    if (code === adyenUnknowErrorCode) {
      parsedResponse = AdyenRefusalResponseParser.parse(message);
      (responseTranslated = AdyenRefusalResponseMapper.get(parsedResponse)),
        this.zuoraLib.sendErrorMessageToHpm(key, responseTranslated);
    } else {
      this.zuoraLib.sendErrorMessageToHpm(key, message);
    }

    this.elements.$submitButton.prop('disabled', false);
  },

  _onZuoraReady() {
    this._getElements();

    this.defaultFieldsValues = {
      creditCardHolderName: this.defaultUserFullName,
    };

    this.zuoraLib.renderWithErrorHandler(
      this.options.zuora_params,
      this.defaultFieldsValues,
      this._onZuoraFormSubmitCallback.bind(this),
      this._onZuoraFormErrorCallback.bind(this)
    );

    this._attachEvents();
    this.validate();
    this._updateElementVisibility();
  },

  _getElements() {
    this.elements.$paymentPanel = this.getWidgetElement('paymentPanel');
    this.elements.$typeSelectContainer = this.getWidgetElement('typeSelect');
  },

  _loadZuoraLib() {
    return lazyScriptLoad(ZUORA_LIB_URL);
  },

  _updateElementVisibility() {
    const selectedPaymentType = this.getPaymentType();
    this.elements.$paymentPanel.toggle(selectedPaymentType !== paymentTypes.PAYPAL);
  },

  _removePaymentWidget() {
    if (this.elements.$placeholder) {
      return;
    }

    this.elements.$placeholder = $('<div />').insertAfter(this.elements.$typeSelectContainer);
    this.elements.$typeSelectContainer.detach();
  },

  _restorePaymentWidget() {
    if (this.elements.$placeholder) {
      this.elements.$typeSelectContainer.insertBefore(this.elements.$placeholder);
      this.elements.$placeholder.remove();
      this.elements.$placeholder = null;
    }

    this._updateElementVisibility();
  },

  enablePaymentTypes() {},

  setPaymentFormSuccessCallback(callback) {
    this._paymentFormSuccessCallback = callback;
  },

  hidePaymentWidget() {
    this._super();
    this._removePaymentWidget();
  },

  showPaymentWidget() {
    this._super();
    this._restorePaymentWidget();
  },

  getPaymentType() {
    return $('input:checked', this.elements.$typeSelectContainer).val();
  },

  validate() {
    this.isValid = this._zuoraFormValided;
  },
});

Widget.paymentTypes = paymentTypes;

export default Widget;
